import React from 'react';
import {Candidates} from './blocks';
import {CandidateDetailsData} from '@/pages/buddy/types/CandidateDetailsData';

interface CandidatesContentProps {
    candidates: CandidateDetailsData[];
    loading: boolean;
}

const CandidatesContent: React.FC<CandidatesContentProps> = ({
                                                     candidates,
                                                     loading,
                                                 }) => {
    return (
        <div>
            {/* Any additional content or components can be added here */}
            <Candidates candidates={candidates} loading={loading} />
        </div>
    );
};

export {CandidatesContent};
